import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import { billingSplitQueryKey } from 'Data/keys/QueryKeys';
import { RateioApi } from 'Data/Rateio.api';
import {
  BillingModeEnum,
  IBillingSplitResponse,
} from 'Data/interfaces/Faturamento/IRateio';
import toastHandler from 'Utils/toastHandler';
import { getApiErrorMessage } from 'Utils/ApiErrorUtils';
import i18n from 'i18n';
import { useRateioScope } from './RateioScope';

export const useMutationBillingMode = () => {
  const { tenantId } = useRateioScope();

  const { mutate, isPending } = useMutation({
    mutationFn: (mode: BillingModeEnum) => {
      return RateioApi.setBillingMode(mode, tenantId);
    },
    onSuccess: (split: IBillingSplitResponse) => {
      queryClient.setQueryData<IBillingSplitResponse>(billingSplitQueryKey(tenantId), split);
    },
    onError: (error: unknown) => {
      toastHandler.showError(getApiErrorMessage(error, i18n.t('faturamento:rateio.errorChangeMode')));
    },
  });

  return {
    setBillingMode: mutate,
    isLoading: isPending,
  };
};
